import checkIsTicketGroupSoldOut from './checkIsTicketGroupSoldOut';
import handleDateTimeBasedScheduled from './ticketScheduledConditions/handleDateTimeBasedScheduled';
import handleAfterTicketSaleEndsScheduled from './ticketScheduledConditions/handleAfterTicketSaleEndsScheduled';
import handleAfterTicketEndsOrSoldOutScheduled from './ticketScheduledConditions/handleAfterTicketEndsOrSoldOutScheduled';
import handleAfterTicketSoldOutScheduled from './ticketScheduledConditions/handleAfterTicketSoldOutScheduled';
import handleUntilEventStartsScheduled from './ticketScheduledConditions/handleUntilEventStartsScheduled';
import handleAlwaysAvailableScheduled from './ticketScheduledConditions/handleAlwaysAvailableScheduled';

/**
 * Checks if a ticket group is scheduled to go on sale in the future
 * @param {Object} ticketGroup - The ticket group to check
 * @param {Array} allTicketGroups - All ticket groups for reference lookups
 * @returns {Object} - { isScheduled: boolean, hasInvalidReference: boolean }
 */
export default function checkIsTicketGroupScheduled({ ticketGroup, allTicketGroups = [] }) {
  if (
    !ticketGroup ||
    ticketGroup.availabilityStatus !== 'available' ||
    ticketGroup.status !== 'enabled'
  ) {
    return { isScheduled: false, hasInvalidReference: false };
  }

  const availabilityBehavior = ticketGroup.availabilityBehavior || 'always_available';
  const now = new Date();
  const entityKey = 'triggerTicketGroup';

  switch (availabilityBehavior) {
    case 'until_event_starts': {
      return handleUntilEventStartsScheduled();
    }
    case 'date_time_based': {
      return handleDateTimeBasedScheduled({ entity: ticketGroup, now });
    }
    case 'after_ticket_sale_ends': {
      return handleAfterTicketSaleEndsScheduled({
        entity: ticketGroup,
        entityKey,
        allEntities: allTicketGroups,
        now,
      });
    }
    case 'after_ticket_ends_or_sold_out': {
      return handleAfterTicketEndsOrSoldOutScheduled({
        entity: ticketGroup,
        entityKey,
        allEntities: allTicketGroups,
        checkSoldOut: checkIsTicketGroupSoldOut,
        now,
      });
    }
    case 'after_ticket_sold_out': {
      return handleAfterTicketSoldOutScheduled({
        entity: ticketGroup,
        entityKey,
        allEntities: allTicketGroups,
        checkSoldOut: checkIsTicketGroupSoldOut,
        now,
      });
    }
    case 'always_available':
    default:
      return handleAlwaysAvailableScheduled();
  }
}
